/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { SurveyFieldDto } from './survey-field-dto';
/**
 *
 *
 * @export
 * @interface CreateSurveyDto
 */
export interface CreateSurveyDto {
  /**
   * Name of the survey.
   *
   * @type {string}
   * @memberof CreateSurveyDto
   * @example Patient Satisfaction Survey
   */
  name: string;

  /**
   * Description of the survey.
   *
   * @type {string}
   * @memberof CreateSurveyDto
   * @example A survey to measure patient satisfaction after each visit.
   */
  description?: string;

  /**
   * Study this survey belongs to.
   *
   * @type {string}
   * @memberof CreateSurveyDto
   * @example clinical-trial-2024
   */
  study?: string;

  /**
   * Template defining the fields to fill in the survey.
   *
   * @type {Array<SurveyFieldDto>}
   * @memberof CreateSurveyDto
   */
  template: Array<SurveyFieldDto>;

  /**
   * Priority level of the survey.
   *
   * @type {string}
   * @memberof CreateSurveyDto
   * @example mandatory
   */
  priority: CreateSurveyDtoPriorityEnum;

  /**
   * How often the survey should be sent, in days.
   *
   * @type {number}
   * @memberof CreateSurveyDto
   * @example 30
   */
  send_frequency_days?: number;

  /**
   * Number of days the participant has to submit a response.
   *
   * @type {number}
   * @memberof CreateSurveyDto
   * @example 7
   */
  response_time_limit_days?: number;

  /**
   * Date when the survey becomes active (ISO 8601).
   *
   * @type {string}
   * @memberof CreateSurveyDto
   * @example 2024-06-01T00:00:00.000Z
   */
  starts_at: string;

  /**
   * Type of the anonymization.
   *
   * @type {string}
   * @memberof CreateSurveyDto
   * @example none
   */
  anonymization_type: CreateSurveyDtoAnonymizationTypeEnum;

  /**
   * Defines who in the organization should receive the survey.
   *
   * @type {string}
   * @memberof CreateSurveyDto
   * @example all_users
   */
  send_strategy: CreateSurveyDtoSendStrategyEnum;

  /**
   * List of organization IDs this survey should be sent to.
   *
   * @type {Array<string>}
   * @memberof CreateSurveyDto
   * @example ["123e4567-e89b-12d3-a456-426614174000"]
   */
  organization_ids: Array<string>;
}

/**
 * @export
 * @enum {string}
 */
export enum CreateSurveyDtoPriorityEnum {
  Mandatory = 'mandatory',
  Optional = 'optional',
}
/**
 * @export
 * @enum {string}
 */
export enum CreateSurveyDtoAnonymizationTypeEnum {
  None = 'none',
  AllAnswers = 'all_answers',
  Optional = 'optional',
}
/**
 * @export
 * @enum {string}
 */
export enum CreateSurveyDtoSendStrategyEnum {
  AllUsers = 'all_users',
  AdminOnly = 'admin_only',
}
